// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2ByRCwNl7ZLjxE1f7JzF5n"};